import React from 'react'

import { Link, LinkProps } from '../../Link'
import { Container, InnerLink, StyledArrow } from './styles'

export interface BreadcrumbItemProps extends LinkProps {
  /**
   * Breadcrumb item index
   */
  index?: number

  /**
   * Is last breadcrumb item
   */
  isLast?: boolean

  /**
   * href attribute
   */
  href: LinkProps['href']

  /**
   * Link `as` prop
   */
  as?: LinkProps['as']

  /**
   * Link `shallow` prop
   */
  shallow?: LinkProps['shallow']

  /**
   * Content
   */
  children?: React.ReactNode
}

/**
 * BreadcrumbItem component
 */
export const BreadcrumbItem = ({
  index,
  isLast,
  children,
  ...linkProps
}: BreadcrumbItemProps) => {
  return (
    <Container
      itemProp="itemListElement"
      itemScope
      itemType="https://schema.org/ListItem"
    >
      {!isLast ? (
        <Link {...linkProps}>
          <InnerLink itemProp="item" active>
            <span itemProp="name">{children}</span>
          </InnerLink>
        </Link>
      ) : (
        <InnerLink as="span" itemProp="name">
          {children}
        </InnerLink>
      )}

      {index !== undefined && (
        <meta itemProp="position" content={`${index + 1}`} />
      )}

      {!isLast && <StyledArrow />}
    </Container>
  )
}

BreadcrumbItem.displayName = 'BreadcrumbItem'
